import { render, staticRenderFns } from "./FormAddress.vue?vue&type=template&id=4620dcca"
import script from "./FormAddress.vue?vue&type=script&lang=ts"
export * from "./FormAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports